import React, { useEffect, useRef, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import NavigoAPIServices from "../services/navigoAPIServices";
import { useHistory, withRouter } from "react-router";
import FontIcon from "react-md/lib/FontIcons";
import EventService from "../../../../../service/event/EventService";
import eyeIcon from "../../../../../assets/icons/eye-orange.svg";
function DisqualificationList(props) {
  const [disqualifyType, setDisqualifyType] = useState();
  const [layout, setLayout] = useState(1);
  const navigoAPIServices = new NavigoAPIServices();

  const [challengeName, setChallengeName] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPID, setSelectedPID] = useState(null);
  const [isChallengeIdDisabled, setIsChallengeIdDisabled] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchPID, setSearchPID] = useState("");
  const [showTable, setShowTable] = useState(false);

  const handleContinue = () => {
    if (!disqualifyType) return;

    navigoAPIServices.getChallengeDetails(
      disqualifyType,
      (res) => {
        setIsChallengeIdDisabled(true);
        setChallengeName(res?.challengeDetails?.name || "");
        setAccountCode(res?.challengeDetails?.accountCode || "");

        // First load with page 1
        setShowTable(true);
        fetchDisqualifiedUsers(1);
      },
      (err) => {
        console.error("Failed to fetch challenge info", err);
        if (!props.isEdit) setLayout(2);
        EventService.emit("showError", { message: err.message });
      }
    );
  };
  const fetchDisqualifiedUsers = (page = pageNo, pid = null) => {
    const body = {
      challengeId: parseInt(disqualifyType),
      pageSize,
      pageNo: page,
    };

    if (pid) {
      body.patientId = pid;
    }

    navigoAPIServices.getDisqualifiedData(
      body,
      (userRes) => {
        setUsers(userRes.disqualifications || []);
        setTotalRecords(userRes.totalCount || 0);
        setPageNo(page);
      },
      (err) => {
        console.error("Failed to fetch disqualified users", err);
        setUsers([]);
        EventService.emit("showError", { message: err.message });
      }
    );
  };

  const handleReactivate = () => {
    const body = {
      patientId: selectedPID,
      challengeId: parseInt(disqualifyType),
    };
    navigoAPIServices.reactivePid(
      body,
      (res) => {
        setShowModal(false);
        handleContinue();
        EventService.emit("showError", {
          message: "User reacivated successfully",
        });
      },
      (err) => {
        console.error(err);
        setShowModal(false);
        EventService.emit("showError", { message: err.message });
      }
    );
  };

  return (
    <div className="navigo-appoint-container-dis">
      <div className="top-bar">
        <div className="header-row">
          <div className="back-icon" onClick={props.changeLayout}>
            <FontIcon style={{ color: "orange" }}>arrow_back</FontIcon>
          </div>
          <h1 className="title">Disqualified users list</h1>
        </div>
      </div>

      <div className="form-row">
        <div className="input-group" style={{ maxWidth: "250px" }}>
          <label>Challenge ID</label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="Type here"
            value={disqualifyType}
            disabled={isChallengeIdDisabled}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, "");
              setDisqualifyType(val);
              if (val === "") {
                setChallengeName("");
                setAccountCode("");
                setUsers([]);
              }
            }}
          />
        </div>

        <button
          className="continue-button"
          onClick={handleContinue}
          disabled={isChallengeIdDisabled}
        >
          Continue
        </button>

        {challengeName && (
          <>
            <div className="input-group">
              <label>Challenge name</label>
              <input type="text" value={challengeName} disabled />
            </div>
            <div className="input-group">
              <label>Account code</label>
              <input type="text" value={accountCode} disabled />
            </div>
          </>
        )}
      </div>

      {showTable && (
        <div className="disqualified-table-container">
          <div className="table-title-row">
            <h3 className="table-title">Disqualified stepathon IDs</h3>
          </div>

          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by PID"
              value={searchPID}
              onChange={(e) => {
                const value = e.target.value;
                setSearchPID(value);

                if (value.trim() === "") {
                  fetchDisqualifiedUsers(pageNo);
                }
              }}
            />
            <FontIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                fetchDisqualifiedUsers(
                  pageNo,
                  searchPID ? parseInt(searchPID) : undefined
                );
              }}
            >
              search
            </FontIcon>
          </div>

          <div className="pagination-container">
            <button
              className="pagination-btn"
              onClick={() => pageNo > 1 && fetchDisqualifiedUsers(pageNo - 1)}
              disabled={pageNo === 1}
            >
              ◀
            </button>
            <span>
              Showing {(pageNo - 1) * pageSize + 1}-
              {Math.min(pageNo * pageSize, totalRecords)} of {totalRecords}
            </span>
            <button
              className="pagination-btn"
              onClick={() =>
                pageNo * pageSize < totalRecords &&
                fetchDisqualifiedUsers(pageNo + 1)
              }
              disabled={pageNo * pageSize >= totalRecords}
            >
              ▶
            </button>
          </div>

          <table className="user-table">
            <thead>
              <tr>
                <th>PID</th>
                <th>Reason for disqualification</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((u) => (
                  <tr key={u.id}>
                    <td>{u.patientId}</td>
                    <td
                      className="ellipsis-cell"
                      dangerouslySetInnerHTML={{ __html: u.reason }}
                    ></td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="view-btn"
                          onClick={() => {
                            setSelectedReason(u.reason);
                            setShowReasonModal(true);
                          }}
                        >
                          <img src={eyeIcon} alt="View Reason" />
                        </button>
                        <button
                          className="remove-btn-orange"
                          onClick={() => {
                            setSelectedPID(u.patientId);
                            setShowModal(true);
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    style={{ textAlign: "center", padding: "16px" }}
                  >
                    No user found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal confirm-modal">
            <p className="modal-message">
              Are you sure you want to again register the disqualified PID:{" "}
              <strong>{selectedPID}</strong> for this challenge?
            </p>
            <div className="modal-actions">
              <button className="confirm-btn" onClick={handleReactivate}>
                Confirm
              </button>
              <button
                className="cancel-btn"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showReasonModal && (
        <div className="modal-overlay">
          <div className="modal">
            <button
              className="modal-close-btn"
              onClick={() => setShowReasonModal(false)}
            >
              &times;
            </button>

            <h3>Reason</h3>
            <div
              className="reason-content"
              dangerouslySetInnerHTML={{ __html: selectedReason }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default withRouter(DisqualificationList);
